import React from "react";
import { useSelector } from "react-redux";
import { selectTransactions } from "../../../redux/merchantSlice";

const P = {
  white: "#FFFFFF", snow: "#FAFAFA", pearl: "#F5F5F0", cloud: "#E8E5DE",
  silver: "#B0ADA6", steel: "#8A8780", graphite: "#5C5955", ink: "#1A1815",
  gold: "#C9A84C", success: "#2D8B5F",
};
const serif = "'Playfair Display', Georgia, serif";
const GOLD_GRAD = "linear-gradient(135deg, #E8C96A, #C9A84C, #9A7A2E)";

export default function Customers() {
  const transactions = useSelector(selectTransactions);

  /* Derive unique customers from transactions */
  const customerMap = new Map<string, { email: string; name: string; country: string; count: number; total: number; currency: string }>();
  transactions.forEach(tx => {
    const key = tx.customer_email || tx.customer_name || tx.id;
    const existing = customerMap.get(key);
    if (existing) {
      existing.count++;
      existing.total += tx.amount;
    } else {
      customerMap.set(key, {
        email: tx.customer_email || "—",
        name: tx.customer_name || "—",
        country: tx.customer_country || "—",
        count: 1,
        total: tx.amount,
        currency: tx.currency,
      });
    }
  });
  const customers = Array.from(customerMap.values());

  return (
    <div>
      <div style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 24, fontFamily: serif, fontWeight: 700, color: P.ink, marginBottom: 6 }}>Customers</h2>
        <p style={{ fontSize: 13, color: P.steel }}>{customers.length} unique customers found from your transactions.</p>
      </div>

      <div style={{ background: P.white, borderRadius: 14, border: `1px solid ${P.cloud}`, overflow: "hidden" }}>
        <div style={{ display: "grid", gridTemplateColumns: "40px 2fr 1.5fr 1fr 1fr 1fr", padding: "12px 24px", borderBottom: `1px solid ${P.pearl}`, gap: 12 }}>
          {["", "Name", "Email", "Country", "Orders", "Total Spent"].map(h => (
            <div key={h} style={{ fontSize: 10, fontWeight: 700, letterSpacing: "0.1em", color: P.silver, textTransform: "uppercase" as const }}>{h}</div>
          ))}
        </div>
        {customers.length === 0 ? (
          <div style={{ padding: "48px 24px", textAlign: "center" }}>
            <div style={{ fontSize: 36, marginBottom: 12, opacity: 0.25 }}>◇</div>
            <div style={{ fontSize: 13, color: P.silver }}>No customer data yet.</div>
          </div>
        ) : (
          customers.slice(0, 25).map((c, i) => (
            <div key={i} style={{ display: "grid", gridTemplateColumns: "40px 2fr 1.5fr 1fr 1fr 1fr", padding: "14px 24px", borderBottom: `1px solid ${P.pearl}`, alignItems: "center", gap: 12, cursor: "pointer", transition: "background .15s" }}
              onMouseEnter={e => (e.currentTarget.style.background = P.snow)} onMouseLeave={e => (e.currentTarget.style.background = "transparent")}>
              <div style={{ width: 32, height: 32, borderRadius: 8, background: GOLD_GRAD, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 800, color: "#0A0A08" }}>
                {(c.name !== "—" ? c.name : c.email).charAt(0).toUpperCase()}
              </div>
              <div style={{ fontSize: 13, fontWeight: 500, color: P.ink }}>{c.name}</div>
              <div style={{ fontSize: 12, color: P.graphite }}>{c.email}</div>
              <div style={{ fontSize: 12, color: P.graphite }}>{c.country}</div>
              <div style={{ fontSize: 12, fontWeight: 600, color: P.ink }}>{c.count}</div>
              <div style={{ fontSize: 13, fontWeight: 600, color: P.ink }}>
                {new Intl.NumberFormat("en-US", { style: "currency", currency: (c.currency || "eur").toUpperCase(), minimumFractionDigits: 2 }).format(c.total / 100)}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}